<div class="display-area grid flex-column justify-content-around align-content-stretch">
  <div style="flex: 1 1 50%;" class="display-area-row1">
    <mat-icon [svgIcon]="type" class="mat-icon {{type}} car-icon"></mat-icon>
  </div>
  <div style="flex: 1 1 50%;" class="display-area-row2 grid flex-nowrap flex-row justify-content-center">
    @if (hasX) {
      <div class="flex-auto" [ngClass]="getClasses('X')">X</div>
    }
    <div class="flex-auto" [ngClass]="getClasses('A')">A</div>
    <div class="flex-auto" [ngClass]="getClasses('U')">U</div>
    <div class="flex-auto" [ngClass]="getClasses('W')">W</div>
  </div>
</div>
